package org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.delete_tag


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Data(
    @SerialName("cashAssist")
    val cashAssist: CashAssist?
)